import { render } from "./noticeDetailGg.vue?vue&type=template&id=3d0dee4e&scoped=true"
import script from "./noticeDetailGg.vue?vue&type=script&lang=js"
export * from "./noticeDetailGg.vue?vue&type=script&lang=js"

import "./noticeDetailGg.vue?vue&type=style&index=0&id=3d0dee4e&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0dee4e"]])

export default __exports__